import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StudentAttendanceLinkComponent } from './student-attendance-link/student-attendance-link.component';
import { StudentAttendanceComponent } from './student-attendance/student-attendance.component';

const routes: Routes = [
   {
                    path:'',component:StudentAttendanceLinkComponent,
                    children:[
                      {
                        path:"StudentAttendances", component:StudentAttendanceComponent
                      },  
                    ]
                  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StudentAttendanceRoutingModule { }
